import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useProfile, useTranslation } from '@front/model'
import { NotReady, Page } from '@components'
import { CloneForm } from './CloneForm'

function CloneToolPage(): ReactElement {
  const { t } = useTranslation()
  const { isTantalim, isLoading } = useProfile()

  if (isLoading) return <NotReady isLoading />
  if (!isTantalim) return <NotReady error={t('Invalid request')} />

  return (
    <Page>
      <Page.Heading title={t('Clone Tool')} />
      <Page.Content scrollArea>
        <CloneForm />
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/cloneTool/')({
  component: CloneToolPage,
})
